import React from 'react';
import './not-found.scss';



export default function NotFound() {


    return (
        <div>
            <h1>Your page was not found</h1>
            <p>Please check your url</p>
        </div>
    );
};
